import { createSlice } from "@reduxjs/toolkit";
import {
  fetchRecordedContacts,
  addRecordedContact,
} from "./recordedContactsThunks";

const recordedContactsSlice = createSlice({
  name: "recordedContacts",
  initialState: {
    contacts: [],
    total: 0,
    loading: false,
    error: null,
    // These hold the currently active filters and sort configuration.
    // For filters, you might store an array of objects like:
    // [{ field: 'firstName', operator: 'contains', value: 'John' }]
    filters: [],
    // For sortModel, an array like:
    // [{ field: 'firstName', sort: 'asc' }]
    sortModel: [],
    currentPage: 1,
    pageSize: 20, // how many contacts to load per request
    hasMore: true, // whether there are more contacts to load
  },
  reducers: {
    setFilters(state, action) {
      //   state.filters = action.payload; - chatgpt
      // append to state.filters, not set it
      state.filters = [...state.filters, ...action.payload];
      // When filters change, reset pagination
      state.currentPage = 1;
      state.contacts = [];
      state.hasMore = true;
    },
    setSortModel(state, action) {
      state.sortModel = action.payload;
      // When sort changes, reset pagination
      state.currentPage = 1;
      state.contacts = [];
      state.hasMore = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecordedContacts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecordedContacts.fulfilled, (state, action) => {
        state.loading = false;
        const { data, page } = action.payload;

        // For the first page, replace the contacts; for later pages, append.
        const contacts = data.data;
        if (page === 1) {
          state.contacts = contacts;
        } else {
          state.contacts = [...state.contacts, ...contacts];
        }
        state.currentPage = page;
        // If the number of contacts received is less than pageSize, there are no more contacts.
        state.hasMore = contacts.length === state.pageSize;
      })
      .addCase(fetchRecordedContacts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add Recorded Contact
      .addCase(addRecordedContact.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addRecordedContact.fulfilled, (state) => {
        state.loading = false;
        state.currentPage = 1;
        state.contacts = [];
        state.hasMore = true; // Force full refresh
      })
      .addCase(addRecordedContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export the actions to update filters and sorting from your UI components.
export const { setFilters, setSortModel } = recordedContactsSlice.actions;
export default recordedContactsSlice.reducer;
